import { useState } from "react";
import {
  Button,
  Grid,
  IconButton,
  ImpressoraAdd,
  MenuButtonList,
  Typography,
} from "../../../../components";
import { PermisoesHelper } from "../../../../helpers";
import MenuAddActions from "./menu-add-actions.component";
import {
  EmailPersonalizadoService,
  ImpressoraService,
  NfSaidaService,
  NotificacaoService,
  notification,
  SessionService,
} from "../../../../services";
import EnvioWhatsappNfeDialog from "./dialogComponents/EnvioWhatsappDialog";
import { useImportContext } from "../../../../contexts/import.context";
import { responseErros, voltar } from "../../../../utils";
import shortid from "shortid";

const nfSaidaService = new NfSaidaService();
const emailPersonalizadoService = new EmailPersonalizadoService();
const notificacaoService = new NotificacaoService();

const ButtonMenu = ({
  id,
  nfSaida,
  onClickCancelarNfSaida,
  onClickEmitirNfSaida,
  onClickCriarContingenciaNfSaidaPendente,
  onClickValidarNfSaida,
  onClickCartaCorrecao,
  onClickConsultarStatus,
  onClickBaixarXml,
  operacaoFiscal,
  permissaoCancelar,
  openDialogEnvioWhatsapp,
  setOpenDialogEnvioWhatsapp,
  envioMensagemBoleto,
  listaIdImpressao,
  emitirAposCadastro,
  setLoading,
}) => {
  const { initialCollapses } = useImportContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const permisoesHelper = new PermisoesHelper();
  const sessionService = new SessionService();
  const usuario = sessionService.getUsuario();
  const empresa = sessionService.getEmpresaRelatorio();
  const impressoraService = new ImpressoraService();
  const permisoesNfSaidaCancelar =
    permisoesHelper.temPermisao("nf-saida-cancelar");
  const isMenuOpen = Boolean(anchorEl);
  const menuId = "primary-add-actions-menu";
  const permissaoEmitir = getPermissaoEmitir(nfSaida, operacaoFiscal);

  const opcoesMenu = [
    { label: "Validar DF-e", onClick: onClickValidarNfSaida },
    ...getOpcoesCancelamento(),
  ];

  async function buscarDanfe() {
    setLoading(true);
    const result =
      nfSaida.status === "CONTINGENCIA"
        ? await nfSaidaService.getDanfeContingencia(nfSaida.id || id, empresa)
        : await nfSaidaService.getDanfe(nfSaida.id || id);
    setLoading(false);
    if (!result.isAxiosError) {
      if (
        nfSaida.modeloDocumento === "65" &&
        nfSaida.empresa.configuracoes?.impressaoDiretaNf
      ) {
        print(result.data);
      } else {
        openAbaDanfeBase64(result.data);
      }
    } else {
      responseErros(result);
    }
  }

  async function buscarDanfeSecundaria() {
    setLoading(true);
    const result = await nfSaidaService.getDanfeSecundaria(
      nfSaida.id || id,
      empresa,
    );
    setLoading(false);
    if (!result.isAxiosError) {
      if (nfSaida.empresa.configuracoes?.impressaoDiretaNf) {
        print(result.data);
      } else {
        openAbaDanfeBase64(result.data);
      }
    } else {
      responseErros(result);
    }
  }

  async function buscarDanfeEspelho() {
    setLoading(true);
    const result = await nfSaidaService.getDanfeEspelho(
      nfSaida.id || id,
      empresa,
    );
    setLoading(false);
    if (!result.isAxiosError) {
      if (nfSaida.empresa.configuracoes?.impressaoDiretaNf) {
        print(result.data);
      } else {
        openAbaDanfeBase64(result.data);
      }
    } else {
      responseErros(result);
    }
  }

  async function print(base64Pdf) {
    setLoading(true);
    try {
      if (!base64Pdf) {
        notification.erroGenericos("Erro ao gerar imagem para impressão.");
        return;
      }
      const body = {
        base64Pdf,
        printerName: nfSaida.empresa?.configuracoes?.impressoraTermica || null,
      };
      const resultImpressao = await impressoraService.imprimirTermicaPdf(body);
      if (!resultImpressao.isAxiosError) {
        notification.sucessoGenericos("Impressão realizada com sucesso!");
      } else {
        responseErros(resultImpressao);
      }
    } catch (error) {
      console.error("Erro na impressão:", error);
      notification.erroGenericos("Erro ao realizar a impressão.");
    } finally {
      setLoading(false);
    }
  }

  async function openAbaDanfeBase64(base64Pdf) {
    try {
      const response = await fetch(`data:application/pdf;base64,${base64Pdf}`);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const pdfWindow = window.open(url, "_blank");
      if (!pdfWindow) {
        notification.alertaGenericos(
          "Popup bloqueado - por favor permita popups para este site",
        );
      }

      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      console.error("Erro ao abrir PDF:", error);
      throw error;
    }
  }

  function getPermissaoEmitir(nfSaida, operacaoFiscal) {
    const { modeloDocumento } = operacaoFiscal;
    const { empresa } = nfSaida;

    return (
      (modeloDocumento === "65" && empresa?.emiteNfce) ||
      (modeloDocumento === "55" && empresa?.emiteNfe)
    );
  }

  function getOpcoesCancelamento() {
    if (
      (nfSaida.status === "PENDENTE" || nfSaida.status === "CONTINGENCIA") &&
      permissaoCancelar
    ) {
      return [
        {
          label: "Cancelar DF-e",
          onClick: onClickCancelarNfSaida,
          disabled: !permisoesNfSaidaCancelar,
        },
      ];
    }
    return [];
  }

  const enviarEmail = async () => {
    if (nfSaida.cliente?.email) {
      setLoading(true);
      try {
        const getPrimeiroNome = (nomeCompleto) => {
          return nomeCompleto?.split(" ")[0] || "";
        };
        const nomeCliente = nfSaida?.cliente?.nomeRazaoSocial;
        const resultEmail = await emailPersonalizadoService.getInformacoesEmail(
          {
            contexto: "nf-saida",
            apelidoFantasia: nfSaida?.empresa?.nome,
            serieDocumento: nfSaida?.serieDocumento,
            numeroDocumento: nfSaida?.numeroDocumento,
            nomeCompletoCliente: nomeCliente,
            primeiroNomeCliente: getPrimeiroNome(nomeCliente),
            nomeUsuario: usuario?.nome,
          },
        );

        if (resultEmail.isAxiosError) {
          const message = resultEmail?.response?.data?.message;
          throw new Error(message ?? "Erro interno de servidor");
        }

        const {
          subject = "Documento referente a Nota Fiscal de Saída",
          text = "Segue nota fiscal de saída solicitada em anexo",
        } = resultEmail.data ?? {};

        let result = false;
        if (
          nfSaida?.status === "ENVIADA" ||
          (!nfSaida?.status &&
            (nfSaida?.modelo === "65" || nfSaida?.modeloDocumento === "55"))
        ) {
          result = await nfSaidaService.getDanfe(nfSaida.id);
        }
        if (
          nfSaida?.status === "FATURADA" ||
          nfSaida?.modeloDocumento === "01"
        ) {
          result = await nfSaidaService.getDanfeSecundaria(
            nfSaida.id,
            nfSaida.empresa,
          );
        }

        if (!result || result.isAxiosError) {
          const message = resultEmail?.response?.data?.message;
          throw new Error(message ?? "Erro interno de servidor");
        }
        const numeroSerie =
          nfSaida?.numeroDocumento && nfSaida?.serieDocumento
            ? `${nfSaida?.serieDocumento}/${nfSaida?.numeroDocumento}`
            : shortid.generate();
        const anexo = {
          filename: `nota-fiscal_${numeroSerie}`,
          type: "application/pdf",
          content: result.data,
        };
        const resultEnvio = await notificacaoService.enviarEmail({
          to: nfSaida.cliente.email,
          subject,
          text,
          attachments: [anexo],
        });
        if (!resultEnvio.isAxiosError) {
          notification.sucessoGenericos("Documento enviado com sucesso");
        } else {
          throw new Error("Erro ao enviar documento via email");
        }
      } catch (error) {
        console.error(error);
        notification.alertaGenericos(error.message);
      } finally {
        setLoading(false);
        initialCollapses();
        if (!nfSaida.status) voltar();
      }
    } else {
      notification.alertaGenericos("Este cliente não possui e-mail cadastrado");
      initialCollapses();
      if (!nfSaida.status) voltar();
    }
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const renderMainButtons = () => {
    if (!id) return null;

    const { status } = nfSaida;

    return (
      <>
        {renderVisualizarButton(status)}
        {renderEspelhoButton(status)}
        {renderStatusButton(status)}
        {renderEmitirButtons(status)}
        {renderEmailButton(status)}
        {renderWhatsappButton(status)}
        {renderMoreActionsButton()}
      </>
    );
  };

  const renderVisualizarButton = (status) => {
    const hiddenStatus = ["PENDENTE", "EM PROCESSAMENTO", "FATURADA"];

    if (!hiddenStatus.includes(status)) {
      return (
        <Button
          id="danfeButton"
          className="my-3"
          variant="outlined"
          color="primary"
          size="small"
          onClick={() => {
            buscarDanfe();
          }}
        >
          Visualizar DF-e
        </Button>
      );
    }
  };

  const renderEspelhoButton = (status) => {
    if (status === "PENDENTE" && nfSaida?.modeloDocumento === "55") {
      return (
        <Button
          className="my-3 ms-2"
          variant="outlined"
          color="primary"
          size="small"
          onClick={buscarDanfeEspelho}
        >
          Espelho DF-e
        </Button>
      );
    }
  };

  const renderStatusButton = (status) => {
    if (status === "EM PROCESSAMENTO") {
      return (
        <Button
          className="my-3 ms-2"
          variant="outlined"
          color="primary"
          size="small"
          onClick={onClickConsultarStatus}
        >
          Consultar DF-e
        </Button>
      );
    }
  };

  const renderEmitirButtons = (status) => {
    if (["PENDENTE", "CONTINGENCIA"].includes(status)) {
      return (
        <>
          {status === "PENDENTE" && nfSaida?.modeloDocumento !== "55" && (
            <Button
              className="my-3 ms-2"
              variant="outlined"
              color="primary"
              size="small"
              disabled={!permissaoEmitir}
              onClick={onClickCriarContingenciaNfSaidaPendente}
            >
              Emitir DF-e em Contingência
            </Button>
          )}
          <MenuButtonList
            className="my-3 ms-2"
            botaoPrincipal={{
              onClick: onClickEmitirNfSaida,
              label: "Emitir DF-e",
            }}
            disabled={!permissaoEmitir}
            opcoes={opcoesMenu}
          />
        </>
      );
    }
  };

  const renderMoreActionsButton = () => (
    <Button
      aria-label="add action caixa"
      aria-controls={menuId}
      aria-haspopup="true"
      aria-expanded={isMenuOpen ? "true" : "false"}
      onClick={handleMenuOpen}
      color="inherit"
      style={buttonStyle}
    >
      <span style={{ fontSize: 10 }}>mais ações</span>
    </Button>
  );

  const renderWhatsappButton = (status) => {
    if (["ENVIADA", "FATURADA"].includes(status)) {
      return (
        <IconButton
          onClick={() => setOpenDialogEnvioWhatsapp(true)}
          size="small"
          sx={{ marginLeft: 1.5 }}
        >
          <i
            className="ph-fill ph-whatsapp-logo"
            style={{ fontSize: 18, color: "#48A34C" }}
          />
        </IconButton>
      );
    }
  };

  const renderEmailButton = (status) => {
    return (
      <IconButton
        id="botaoEmailAction"
        onClick={enviarEmail}
        size="small"
        sx={{
          marginLeft: 1.5,
          display: ["FATURADA", "ENVIADA"].includes(status)
            ? "inline-flex"
            : "none",
        }}
      >
        <i className="ph-fill ph-envelope" style={{ fontSize: 18 }} />
      </IconButton>
    );
  };

  const buttonStyle = {
    borderRadius: 5,
    backgroundColor: "#E5E5E5",
    margin: "1em",
  };

  return (
    <>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ mb: "0.5em" }}
      >
        {renderMainButtons()}
        <div className="invisible" style={{ width: 5, height: 5 }}>
          <ImpressoraAdd descricaoBotao="Visualizar DF-e" />
        </div>
        {nfSaida.status === "CANCELADO" && (
          <Typography style={{ color: "red" }}>CANCELADO</Typography>
        )}
      </Grid>
      <MenuAddActions
        id={id}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        nfSaida={nfSaida}
        onClickCancelarNfSaida={onClickCancelarNfSaida}
        onClickCartaCorrecao={onClickCartaCorrecao}
        onClickBaixarXml={onClickBaixarXml}
        permissaoCancelar={permissaoCancelar}
        configuracoes={nfSaida?.empresa?.configuracoes}
        buscarDanfeSecundaria={buscarDanfeSecundaria}
      />
      <EnvioWhatsappNfeDialog
        open={openDialogEnvioWhatsapp}
        setOpen={setOpenDialogEnvioWhatsapp}
        nfSaida={nfSaida}
        envioMensagemBoleto={envioMensagemBoleto}
        listaIdImpressao={listaIdImpressao}
        emitirAposCadastro={emitirAposCadastro}
        initialCollapses={initialCollapses}
      />
    </>
  );
};

export default ButtonMenu;
